import { IBasicReturn } from '@interfaces/IBasicReturn';
import { IError } from '@interfaces/IError';
import appAxiosInstance from '../../../Utils/appAxiosInstance';

const saveError = async (values: IError): Promise<IBasicReturn> => {
  let savedError: IBasicReturn = {
    Success: true,
  };

  await appAxiosInstance().post<IBasicReturn>('Error/Add', values)
    .then((response): IBasicReturn => {
      const { data } = response;
      savedError = data;
      return savedError;
    })
    .catch((): IBasicReturn => {
      savedError.Success = false;
      return savedError;
    });

  return savedError;
};

export default saveError;
